import script from "./FloatButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./FloatButton.vue?vue&type=script&setup=true&lang=ts"

import "./FloatButton.vue?vue&type=style&index=0&id=c651146e&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c651146e"]])

export default __exports__